import React from "react";
import { QuestionStep, QuestionStepProps } from "./QuestionStep";
import { URLInput } from "@xapp/components";

export type FacebookPageQuestionStepProps = Omit<
    QuestionStepProps<string>,
    "title" | "hasValueLabel" | "noValueLabel" | "valueLabel" | "renderInput" | "canClickNext"
>;

export const FacebookPageQuestionStep = (props: FacebookPageQuestionStepProps) => {
    return (
        <QuestionStep<string>
            title="Do you have a business Facebook page?"
            description={
                <>
                    <p>
                        A Facebook page for your business can serve as your primary digital storefront or a place to
                        communicate with new and existing customers.
                    </p>
                    <br />
                    <p>
                        If you don't have a website, you can leverage our hosted contact pages for potential customers
                        to book appointments with you.
                    </p>
                </>
            }
            hasValueLabel="I have a Facebook page"
            hasValueDescription="Great!  We will provide you with a booking link you can use in your Facebook page."
            noValueLabel="I don't have a Facebook page yet"
            noValueDescription="No problem!  You don't necessarily need one but if you create one later you can use the same booking link."
            initialValue={props.initialValue || ""}
            renderInput={(value, setValue, disabled) => {
                return (
                    <URLInput
                        label="Facebook Page"
                        onChange={(val: string, valid: boolean) => setValue(val)}
                        disabled={disabled}
                        requiredBaseUrl="https://facebook.com/"
                        value={value}
                    />
                );
            }}
            canClickNext={(hasValue, value) => {
                // if (hasValue) {
                //     return !!value && validateURL(value).valid;
                // }
                return typeof hasValue === "boolean" ? true : false;
            }}
            {...props}
        />
    );
};
